<template>
    <div class="calendar">
        <div class="month">
            {{ date.format('MMM').replace(/[.]/g, "").toUpperCase() }}
        </div>
        <div class="date">
            <div class="nr">
                {{ date.format('DD').replace(/^0+/g, "") }}
            </div>
            <div class="day">
                {{ date.format('ddd').replace(/[.]/g, "").toUpperCase() }}
            </div>
        </div>
    </div>
</template>

<script>
  import moment from 'moment';
  import 'moment/locale/nl';

  export default {
    props: {
      date: moment('2019-01-01') // YYYY-MM-DD
    },
    created () {
      moment.locale('nl');
    }
  };
</script>

<style scoped type="scss">
  .calendar {
    display: flex;
    flex-direction: column;
    width: 65px;
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2);
  }
  .month {
    background-color: rgb(88, 88, 88);
    color: white;
    text-align: center;
    font-size: 0.8rem;
    font-weight: bold;
  }
  .date {
    text-align: center;
  }
  .nr {
    padding-top: 4px;
    line-height: 1em;
    font-weight: bold;
    font-size: 30px;
  }
  .day {
    font-weight: bold;
    color: rgb(173, 173, 173);
    font-size: 0.8rem;
    padding-bottom: 3px;
  }
</style>

